module.exports = __webpack_public_path__ + "static/media/EH.0d0afee7.svg";